import { ChatToolApproval } from "src/base-components/Chat/ChatToolApproval";
import { ToolUse } from "src/clients/copilot";

type Props = {
  toolUse: ToolUse;
  onApprove: () => void;
  onDeny: () => void;
  disabled?: boolean;
  delay?: number;
};

type ToolInput = {
  schema_name?: string;
  table_name?: string;
  tables?: { table_name: string }[];
};

const getToolDescription = (
  toolName: string,
  toolInput: ToolInput,
): React.ReactNode => {
  switch (toolName) {
    case "get_tables":
      return "Allow Copilot to fetch the list of all available tables";
    case "get_table_details":
      return (
        <span>
          Allow Copilot to retrieve column details for the{" "}
          <span className="font-code-12">
            {toolInput.schema_name}.{toolInput.table_name}
          </span>{" "}
          table
        </span>
      );
    case "get_batch_table_details":
      return (
        <span>
          Allow Copilot to fetch details for the following tables:
          <ul className="list-inside list-disc">
            {toolInput.tables?.map((table: { table_name: string }) => (
              <li key={table.table_name} className="rounded-md font-code-12">
                {table.table_name}
              </li>
            ))}
          </ul>
        </span>
      );

    default:
      return `Allow Copilot to use ${toolName}`;
  }
};

export const ToolApprovalCard: React.FC<Props> = ({
  toolUse,
  onApprove,
  onDeny,
  disabled = false,
  delay = 0,
}) => {
  const description = getToolDescription(toolUse.tool_name, toolUse.tool_input);

  return (
    <ChatToolApproval
      delay={delay}
      description={description}
      disabled={disabled}
      onApprove={onApprove}
      onDeny={onDeny}
    />
  );
};
